import { render, staticRenderFns } from "./profile-graph.vue?vue&type=template&id=0420f87a&"
import script from "./profile-graph.vue?vue&type=script&lang=ts&"
export * from "./profile-graph.vue?vue&type=script&lang=ts&"
import style0 from "./profile-graph.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports